import giftCardAddon from './giftCardAddon'

const integration = {
  giftCardAddon,
}

export default integration
